import { Box } from '@/components/shared/layout/box';
import { styled } from '@/stitches.config';

export const StyledProductEngineGearGrid = styled(Box, {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto auto',
  '@md': {
    gridTemplateColumns: 'repeat(8, 1fr)',
    gridTemplateRows: 'auto',
    columnGap: '$space-5',
  },
  '@lg': {
    gridTemplateColumns: 'repeat(12, 1fr)',
    columnGap: '$space-6',
  },
});
